var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.bundle
    ? _c("ul", [
        _c("li", [
          _vm._v(
            _vm._s(_vm.$t("bundle.packageNr")) +
              " " +
              _vm._s(_vm.bundle.strBundleNo)
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            _vm._s(_vm.$t("bundle.length")) +
              " " +
              _vm._s(_vm.bundle.intLength) +
              " " +
              _vm._s(_vm.$t("unit.cm"))
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            _vm._s(_vm.$t("bundle.width")) +
              " " +
              _vm._s(_vm.bundle.intWidth) +
              " " +
              _vm._s(_vm.$t("unit.cm"))
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            _vm._s(_vm.$t("bundle.sheets")) + " " + _vm._s(_vm.bundle.intSheets)
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            _vm._s(_vm.$t("bundle.area")) +
              " " +
              _vm._s(_vm.bundle.decArea) +
              " " +
              _vm._s(_vm.$t("unit.sqm"))
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }